module.exports = __webpack_public_path__ + "static/plan-s7-36668d07e01e8dcca816a386006da3c4.jpg";